<template lang="pug">
.content
  el-table(highlight-current-row size="small"  height="350px" :data="dataTabel" border)
    el-table-column(
      v-for="(value,key) in tableHeader"
      :prop="key" :label="value" :key="key")
</template>

<script>
export default {
  props: {
    excelData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tableHeader() {
      return this.excelData[0];
    },
    dataTabel() {
      return this.excelData.filter((item, index) => index !== 0);
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>

</style>
